import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=7c812add&scoped=true&"
import script from "./FollowButton.vue?vue&type=script&lang=js&"
export * from "./FollowButton.vue?vue&type=script&lang=js&"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=7c812add&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c812add",
  null
  
)

export default component.exports